import { render, staticRenderFns } from "./basic-access-key-form.vue?vue&type=template&id=b337c888"
import script from "./basic-access-key-form.vue?vue&type=script&lang=js"
export * from "./basic-access-key-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports